import { render, staticRenderFns } from "./RoomLounge.vue?vue&type=template&id=4b2289e3&scoped=true"
import script from "./RoomLounge.vue?vue&type=script&lang=ts"
export * from "./RoomLounge.vue?vue&type=script&lang=ts"
import style0 from "./RoomLounge.vue?vue&type=style&index=0&id=4b2289e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2289e3",
  null
  
)

export default component.exports